import React , {useEffect}  from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
    display:flex;
    flex-direction: column;
    // margin: 30px 100px 100px;
`;

const Title = styled.div`
   font-size: 40px;
   display:flex;
   color: #385963;
   font-weight: 600;
   margin-bottom: 50px;
  justify-content: left;
`;

const Description = styled.div`
   font-size: 20px;
   margin-bottom: 20px;
   color:#91abb3;
   display:flex;
   justify-content: left;
`;

const Reviews = () => {
  return (
    <Container>
    <Title>REVIEWS</Title>
    <Description>Διάβασε τις βαθμολογίες άλλων επισκεπτών και μην διστάσεις να αφήσεις μια δική σου αξιολόγηση!</Description>   
    </Container>
  )
}

export default Reviews
